import { useState } from "react";
import { useSelector } from "react-redux";
// components
import SortModal from "../sortModal";
import CardsList from "./cardsList";
import Sort from "./sort";
const CardsFilter = (props) => {
	const [modalState, setModalState] = useState(false);
	const global = useSelector((state) => state.global);
  const cards = useSelector((state) => state.initialData.cards);
	const modalSortState = () => {
		setModalState(false);
	};
	return (
		<>
			<div className="sorting-filters">
				<div className="cards cards--small">
					{global.localization.selectedCards ? (
						<h2 className="sorting-filters__label">
							{global.localization.selectedCards}
						</h2>
					) : null}
					<CardsList list={cards} />
				</div>
				<Sort callback={setModalState} global={global}/>
			</div>
			<SortModal
				toggleModal={modalState}
				callback={modalSortState}></SortModal>
		</>
	);
};
export default CardsFilter;
